import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import FilterComponent from 'shared/components/tables/interactive/components/fancy_filter/filter_selector/FilterComponent';

const PayrollUpdateStatus = observer(({filter, filterKey, filterUpdated, filterDeleted, Wrapper}) => {
  const options = [
    { label: t('components.tables.fancy_filters.selectors.Pending'), value: 'submitted' },
    { label: t('components.tables.fancy_filters.selectors.Completed'), value: 'completed' }
  ];

  return <FilterComponent filter={filter} filterKey={filterKey} options={options} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
});

export default PayrollUpdateStatus;
